// extracted by mini-css-extract-plugin
module.exports = {"headlightWrapper":"headlight__headlightWrapper__Eb8Uf"};